import { gql } from '@apollo/client'
import { BASIC_PRODUCT_FRAGMENT } from './BasicProductFragment'

export const BASIC_BOUNDING_BOXES_FRAGMENT = gql`
  fragment BasicBoundingBoxes on BoundingBoxSet {
    id
    created
    modified
    verified
    boundingBoxes {
      id
      label
      confidence
      coordinates {
        minX
        maxX
        minY
        maxY
      }
    }
  }
  ${BASIC_PRODUCT_FRAGMENT}
`
